import { type useTimeout } from '@mantine/hooks'
import { createContext } from 'react'

import { type UNSAFE_any } from '@flecto/types'

export * from './usePopoverTrackedState'

export type PopoverTrackedContextState = {
  popoverId: string
  height: number
  width: number
  position: PopoverPosition
  handleMove: ReturnType<typeof useTimeout>
  handleClose: ReturnType<typeof useTimeout>
}

export type PopoverPosition = {
  bottom?: number
  left?: number
  right?: number
  top?: number
}

export const PopoverTrackedContext = createContext<PopoverTrackedContextState>({
  popoverId: '',
  height: 0,
  width: 0,
  position: {
    bottom: undefined,
    left: undefined,
    right: undefined,
    top: undefined,
  },
  handleMove: {
    start: (..._args: UNSAFE_any[]) => ({}),
    clear: () => ({}),
  },
  handleClose: {
    start: (..._args: UNSAFE_any[]) => ({}),
    clear: () => ({}),
  },
})
